import { render, staticRenderFns } from "./chateau-pontet-canet.vue?vue&type=template&id=28f261ed&scoped=true"
import script from "./chateau-pontet-canet.vue?vue&type=script&lang=js"
export * from "./chateau-pontet-canet.vue?vue&type=script&lang=js"
import style0 from "./chateau-pontet-canet.vue?vue&type=style&index=0&id=28f261ed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f261ed",
  null
  
)

export default component.exports